<template>
  <div>
    <Login v-if="!this.isAuthenticated2" @loginComplete="updateUser" />
    <NavBar
      v-if="this.isAuthenticated2 !== false && this.user !== null"
    ></NavBar>
    <DealerForm
      v-if="this.isAuthenticated2 !== false && this.user !== null"
    ></DealerForm>
  </div>
</template>

<script>
//import authentication from './authentication'
import auth from "./services/auth";
import { identifyUxcamUser, trackUxcamEvent } from "./services/uxcam";
import NavBar from "./components/NavBar.vue";
import Login from "./components/Login.vue";
import DealerForm from "./components/DealerForm.vue";

export default {
  data() {
    return {
      user: null,
      isAuthenticated2: false,
    };
  },
  name: "app",
  components: {
    NavBar: NavBar,
    Login: Login,
    DealerForm: DealerForm,
  },
  created() {
    // Force HTTPS redirect
    if (
      process.env.VUE_APP_ENV === "production" &&
      window.location.protocol === "http:"
    ) {
      window.location.href = window.location.href.replace("http:", "https:");
      return;
    }

    // Restore theme preference (only if user explicitly chose dark)
    if (localStorage.getItem('theme') === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    }

    document.title = "Sea Tow Membership Web App";
    if (process.env.VUE_APP_O365_CLIENTID) {
      auth.configure(process.env.VUE_APP_O365_CLIENTID, false);

      // Pre-existing sessions (from before the 30-day policy) start their window
      // at this load rather than being forced to re-login immediately.
      auth.seedExistingSession();

      // Restore any cached or saved local user
      this.user = auth.user();

      if (this.user) {
        this.isAuthenticated2 = true;
        identifyUxcamUser(this.user);
        this.trackScreen("dealer_form");
      } else {
        this.isAuthenticated2 = false;
        this.trackScreen("login");
      }
      console.log(`configured is: ${auth.isConfigured()}`);
    } else {
      this.error =
        "VUE_APP_CLIENT_ID is not set, the app will not function! 😥";
    }
  },
  watch: {
    // If user changes, make calls to Graph API
    auth: async function () {
      this.user = this.auth.user();
    },
    user: async function () {
      this.fetchGraphDetails;
    },
  },
  methods: {
    isAuthenticated() {
      var user = auth.user();
      if (user !== undefined && user !== null) {
        this.isAuthenticated2 = true;
        return true;
      } else {
        this.isAuthenticated2 = false;
        return false;
      }
    },
    // Update user from MSAL
    updateUser() {
      this.user = auth.user();
      this.isAuthenticated();
      if (this.user) {
        identifyUxcamUser(this.user);
        trackUxcamEvent("login_succeeded");
        this.trackScreen("dealer_form");
      }
    },
    // The app is a single route, so UXCam's URL-based page naming cannot tell
    // the login screen from the form. Emit the screen as an event; it does not
    // get a user property, which would spend one of the 20 slots on something
    // the event timeline already shows.
    trackScreen(screen) {
      trackUxcamEvent("screen_view", { screen });
    },
  },
};
</script>

<style>
/* --- Theme variables --- */
:root {
  --bg-page: #f9fafb;
  --bg-surface: #ffffff;
  --bg-hover: #f3f4f6;
  --bg-input: #ffffff;
  --bg-table-head: #f9fafb;

  --text-primary: #1f2937;
  --text-secondary: #374151;
  --text-muted: #6b7280;
  --text-faint: #9ca3af;

  --border-default: #e5e7eb;
  --border-input: #d1d5db;

  --accent: #111827;
  --accent-hover: #1f2937;
  --accent-active: #030712;
  --accent-text: #ffffff;

  --error-bg: #fef2f2;
  --error-border: #fecaca;
  --error-text: #dc2626;

  --shadow-sm: rgba(0, 0, 0, 0.04);
  --shadow-md: rgba(0, 0, 0, 0.1);
  --shadow-lg: rgba(0, 0, 0, 0.12);

  --checkbox-bg: #111827;
  --checkbox-border: #111827;
}

[data-theme="dark"] {
  --bg-page: #111827;
  --bg-surface: #1f2937;
  --bg-hover: #374151;
  --bg-input: #374151;
  --bg-table-head: #1f2937;

  --text-primary: #f9fafb;
  --text-secondary: #e5e7eb;
  --text-muted: #9ca3af;
  --text-faint: #6b7280;

  --border-default: #374151;
  --border-input: #4b5563;

  --accent: #e5e7eb;
  --accent-hover: #f3f4f6;
  --accent-active: #d1d5db;
  --accent-text: #111827;

  --error-bg: #450a0a;
  --error-border: #7f1d1d;
  --error-text: #fca5a5;

  --shadow-sm: rgba(0, 0, 0, 0.2);
  --shadow-md: rgba(0, 0, 0, 0.4);
  --shadow-lg: rgba(0, 0, 0, 0.5);

  --checkbox-bg: #e5e7eb;
  --checkbox-border: #e5e7eb;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  background: var(--bg-page);
}

/* --- Global form polish --- */

/* Cards */
.card {
  border: 1px solid var(--border-default) !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 2px var(--shadow-sm) !important;
  margin-bottom: 1rem;
  background-color: var(--bg-surface) !important;
}

.card.bg-light {
  background-color: var(--bg-surface) !important;
}

/* Form inputs */
.form-control {
  border: 1px solid var(--border-input);
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  background-color: var(--bg-input);
  color: var(--text-primary);
}

.form-control:focus {
  border-color: var(--text-muted);
  box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.1);
  background-color: var(--bg-input);
  color: var(--text-primary);
}

/* Select dropdowns */
.custom-select {
  background-color: var(--bg-input);
  color: var(--text-primary);
  border-color: var(--border-input);
}

/* Section labels */
.col-form-label-lg {
  font-size: 1.1rem !important;
  letter-spacing: -0.01em;
}

/* Buttons */
.btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.15s ease;
}

.btn-primary {
  background-color: var(--accent);
  border-color: var(--accent);
  color: var(--accent-text);
}

.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--accent-hover);
  border-color: var(--accent-hover);
  box-shadow: 0 1px 4px var(--shadow-lg);
  color: var(--accent-text);
}

.btn-primary:active {
  background-color: var(--accent-active) !important;
  border-color: var(--accent-active) !important;
}

.btn-outline-secondary {
  color: var(--text-secondary);
  border-color: var(--border-input);
}

.btn-outline-secondary:hover {
  background-color: var(--bg-hover);
  border-color: var(--border-input);
  color: var(--text-primary);
}

.btn-outline-primary {
  color: var(--accent);
  border-color: var(--accent);
}

.btn-outline-primary:hover {
  background-color: var(--accent);
  border-color: var(--accent);
  color: var(--accent-text);
}

/* Tables */
.table {
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.table thead th {
  background: var(--bg-table-head);
  border-bottom: 2px solid var(--border-default);
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.table td {
  vertical-align: middle;
  border-color: var(--border-default);
}

/* Toasts */
.b-toast .toast {
  border-radius: 10px;
  box-shadow: 0 4px 20px var(--shadow-lg);
}

/* Custom checkboxes & radios */
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--checkbox-bg);
  border-color: var(--checkbox-border);
}

/* Spacing under navbar */
.dealer-form-wrapper {
  padding-top: 1rem;
}

/* ===========================
   Bootstrap dark mode overrides
   =========================== */
[data-theme="dark"] body,
[data-theme="dark"] #app {
  background-color: var(--bg-page);
  color: var(--text-primary);
}

/* Card headers */
[data-theme="dark"] .card-header {
  background-color: var(--bg-hover) !important;
  border-bottom-color: var(--border-default) !important;
  color: var(--text-primary) !important;
}

/* Form labels */
[data-theme="dark"] label,
[data-theme="dark"] .form-group label,
[data-theme="dark"] .col-form-label,
[data-theme="dark"] .col-form-label-lg,
[data-theme="dark"] .custom-control-label {
  color: var(--text-primary) !important;
}

/* Radio & checkbox controls */
[data-theme="dark"] .custom-control-label::before {
  background-color: var(--bg-input);
  border-color: var(--border-input);
}

[data-theme="dark"] .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

/* Form select (Bootstrap-Vue b-form-select) */
[data-theme="dark"] .form-control,
[data-theme="dark"] .custom-select,
[data-theme="dark"] select.form-control {
  background-color: var(--bg-input) !important;
  color: var(--text-primary) !important;
  border-color: var(--border-input) !important;
}

/* Input group addons ($ prefix, etc.) */
[data-theme="dark"] .input-group-text {
  background-color: var(--bg-hover);
  border-color: var(--border-input);
  color: var(--text-secondary);
}

/* Alerts */
[data-theme="dark"] .alert-warning {
  background-color: #78350f;
  border-color: #92400e;
  color: #fef3c7;
}

[data-theme="dark"] .alert-danger {
  background-color: var(--error-bg);
  border-color: var(--error-border);
  color: var(--error-text);
}

[data-theme="dark"] .alert-info {
  background-color: #1e3a5f;
  border-color: #1e40af;
  color: #bfdbfe;
}

/* Badges */
[data-theme="dark"] .badge-secondary {
  background-color: var(--bg-hover);
  color: var(--text-secondary);
}

[data-theme="dark"] .badge-primary {
  background-color: #3b82f6;
  color: #ffffff;
}

[data-theme="dark"] .badge-info {
  background-color: #1e40af;
  color: #bfdbfe;
}

/* Modals */
[data-theme="dark"] .modal-content {
  background-color: var(--bg-surface);
  border-color: var(--border-default);
  color: var(--text-primary);
}

[data-theme="dark"] .modal-header {
  border-bottom-color: var(--border-default);
}

[data-theme="dark"] .modal-footer {
  border-top-color: var(--border-default);
}

[data-theme="dark"] .close {
  color: var(--text-muted);
  text-shadow: none;
}

/* List groups */
[data-theme="dark"] .list-group-item {
  background-color: var(--bg-surface);
  border-color: var(--border-default);
  color: var(--text-primary);
}

/* Tables */
[data-theme="dark"] .table {
  color: var(--text-primary);
  background-color: var(--bg-surface);
}

[data-theme="dark"] .table-bordered,
[data-theme="dark"] .table-bordered th,
[data-theme="dark"] .table-bordered td {
  border-color: var(--border-default) !important;
}

[data-theme="dark"] .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.03);
}

[data-theme="dark"] .table td,
[data-theme="dark"] .table th {
  border-color: var(--border-default);
}

/* Text utilities */
[data-theme="dark"] .text-muted {
  color: var(--text-muted) !important;
}

[data-theme="dark"] .text-secondary {
  color: var(--text-muted) !important;
}

[data-theme="dark"] .text-dark {
  color: var(--text-primary) !important;
}

[data-theme="dark"] .text-primary {
  color: #60a5fa !important;
}

[data-theme="dark"] .text-success {
  color: #4ade80 !important;
}

[data-theme="dark"] .text-danger {
  color: #f87171 !important;
}

[data-theme="dark"] .text-info {
  color: #38bdf8 !important;
}

/* Background utilities */
[data-theme="dark"] .bg-light {
  background-color: var(--bg-surface) !important;
}

[data-theme="dark"] .bg-white {
  background-color: var(--bg-surface) !important;
}

/* Toast overrides
   BootstrapVue's variant rules are more specific than a bare
   [data-theme="dark"] .toast-header (`.b-toast-danger .toast .toast-header` is
   0-3-0 against 0-2-0), so the light pastel header survived dark mode while the
   body went dark - a light header on a dark body, with the muted close button
   nearly invisible on it. Each variant sets its palette as custom properties
   and one set of rules consumes them, scoped through .b-toast so every selector
   outranks the vendor's. */
[data-theme="dark"] .b-toast-success .toast {
  --toast-bg: #14532d;
  --toast-border: #166534;
  --toast-header-bg: #166534;
  --toast-header-text: #dcfce7;
}

[data-theme="dark"] .b-toast-danger .toast {
  --toast-bg: #450a0a;
  --toast-border: #7f1d1d;
  --toast-header-bg: #7f1d1d;
  --toast-header-text: #fee2e2;
}

[data-theme="dark"] .b-toast-warning .toast {
  --toast-bg: #78350f;
  --toast-border: #92400e;
  --toast-header-bg: #92400e;
  --toast-header-text: #fef3c7;
}

[data-theme="dark"] .b-toast-info .toast {
  --toast-bg: #1e3a5f;
  --toast-border: #1e40af;
  --toast-header-bg: #1e40af;
  --toast-header-text: #dbeafe;
}

/* Fallbacks cover the unstyled default toast, which sets no variant. */
[data-theme="dark"] .b-toast .toast,
[data-theme="dark"] .b-toast.b-toast-solid .toast {
  background-color: var(--toast-bg, var(--bg-surface));
  border-color: var(--toast-border, var(--border-default));
  color: var(--text-primary);
}

[data-theme="dark"] .b-toast .toast .toast-header {
  background-color: var(--toast-header-bg, var(--bg-hover));
  border-bottom-color: var(--toast-border, var(--border-default));
  color: var(--toast-header-text, var(--text-primary));
}

[data-theme="dark"] .b-toast .toast .close {
  color: var(--toast-header-text, var(--text-primary));
  text-shadow: none;
  opacity: 0.75;
}

[data-theme="dark"] .b-toast .toast .close:hover,
[data-theme="dark"] .b-toast .toast .close:focus {
  color: var(--toast-header-text, var(--text-primary));
  opacity: 1;
}

/* Spinner */
[data-theme="dark"] .spinner-border {
  color: var(--text-muted);
}

/* Dropdown (Bootstrap native) */
[data-theme="dark"] .dropdown-menu {
  background-color: var(--bg-surface);
  border-color: var(--border-default);
}

[data-theme="dark"] .dropdown-item {
  color: var(--text-primary);
}

[data-theme="dark"] .dropdown-item:hover {
  background-color: var(--bg-hover);
  color: var(--text-primary);
}
</style>
